import React from "react";
import styled from "@emotion/styled";
import { Line } from "react-chartjs-2";

import Paper from "@mui/material/Paper";

import ParkkiTheme from "themes/ParkkiTheme";
import Placeholder from "./Placeholder";
import { useGrapContext } from "services/graphs/GraphProvider";

const Container = styled(Paper)`
  position: relative;
  display: flex;
  flex-direction: row;
  font-family: "Source Sans Pro", sans-serif;
  height: 300px;
  padding-right: ${ParkkiTheme.spacings.base};
  padding-left: ${ParkkiTheme.spacings.base};
  padding-top: ${ParkkiTheme.spacings.base};
  padding-bottom: ${ParkkiTheme.spacings.tiny};
`;

type Props = {
  stats: { toggle: boolean };
  graphOptions: object;
  initialized: boolean;
};

function ChronologyChart({
  stats,
  graphOptions,
  initialized,
}: Props): JSX.Element {
  const { setRef }: any = useGrapContext();
  if (!stats?.toggle) return <></>;

  if (!initialized) {
    return <Placeholder delay={500} height="330px" />;
  }

  return (
    <Container>
      <Line data={stats} options={graphOptions} ref={(el) => setRef(el)} />
    </Container>
  );
}

export default ChronologyChart;
